import { render, staticRenderFns } from "./DrugAllocations.vue?vue&type=template&id=48ef19a3&scoped=true&"
import script from "./DrugAllocations.vue?vue&type=script&lang=js&"
export * from "./DrugAllocations.vue?vue&type=script&lang=js&"
import style0 from "./DrugAllocations.vue?vue&type=style&index=0&id=48ef19a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef19a3",
  null
  
)

export default component.exports